import React, { useState } from 'react';
import { Modal, View, Text, Image, ScrollView, TouchableOpacity } from 'react-native';
import {
  ActivityIndicator,
  Provider as PaperProvider,
} from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import { useCommunity } from './ContextCommunity/CommunityContext';
import { Feather } from '@expo/vector-icons';
import { Ionicons } from '@expo/vector-icons';
import CardCommunity from './CardCommunity';
import Button from '../../components/Button';
import THEME from '../../config/theme';
import * as S from './style';
import {
  Container,
  SmallText,
  StandardText,
} from '../../config/theme/globalStyles';
import Header from '../../components/Header';
import BrandInput from '../../components/BrandInput';
import { useCustomTheme } from '../../contexts/useCustomTheme';
import { removeSansSerif } from '../../utils/validators';
import { hexToRgba } from '../../utils/colorUtils';
import ManageChannelsModal from './ManageChannelsModal';
import ChannelFormModal from './ChannelFormModal';
import EditChannelModal from './EditChannelModal';
import ChannelManager from './ChannelManager';

const Community = () => {
  const {
    isPostModalVisible,
    setIsPostModalVisible,
    textContent,
    setTextContent,
    image,
    posts,
    loading,
    isUser,
    openImagePicker,
    closeModal,
    handlePost,
    isAnonymous,
    messageImageError,
    loadingCard,
    setPosts,
    handleDeletePost,
    handleLike,
    channels,
    allChannels,
    selectedChannelId,
    setSelectedChannelId,
    createChannel,
    updateChannel,
    deleteChannel,
    moveChannel,
    canUserPostOnSelectedChannel,
  } = useCommunity();

  const navigation = useNavigation();

  const { customColor, customFont } = useCustomTheme();

  // ── Tokens da MARCA DO CLIENTE ────────────────────────────────────────────
  // Tela de aluno: nada de paleta do admin aqui. Superfícies, bordas e texto
  // secundário são derivados da cor de texto da marca, então funcionam igual em
  // tema claro e escuro sem precisar de cores fixas.
  const clientBg = customColor?.background?.app || THEME.COLORS.BACKGROUND_MAIN;
  const clientText = customColor?.text?.app || THEME.COLORS.TEXT_MAIN;
  const clientBtnBg = customColor?.button?.backgroundApp || THEME.COLORS.PRIMARY_900;
  const clientBtnText = customColor?.button?.textApp || THEME.COLORS.TEXT_BUTTON;
  const cFontTitle = customFont?.fontFamilySubtitle
    ? removeSansSerif(customFont.fontFamilySubtitle)
    : THEME.FONTFAMILY.MEDIUM;
  const cFontText = customFont?.fontFamilyText
    ? removeSansSerif(customFont.fontFamilyText)
    : THEME.FONTFAMILY.REGULAR;
  const cSurface = hexToRgba(clientText, 0.05) || '#FFFFFF';
  const cBorder = hexToRgba(clientText, 0.15) || '#E5E7EB';
  const cMuted = hexToRgba(clientText, 0.6) || '#6B7280';

  const [isManageChannelsModalVisible, setIsManageChannelsModalVisible] = useState(false);
  const [isCreateChannelModalVisible, setIsCreateChannelModalVisible] = useState(false);
  const [isEditChannelModalVisible, setIsEditChannelModalVisible] = useState(false);
  const [channelToEdit, setChannelToEdit] = useState(null);

  // O listener de Dimensions que existia aqui só alimentava a largura fixa do
  // modal antigo. O modal novo é responsivo por `maxWidth`, então saiu junto —
  // e com ele o `Dimensions.removeEventListener`, API já removida do RN, que
  // quebraria na desmontagem da tela.

  if (isAnonymous) {
    return (
      <Container
        justifyContent="center"
        style={{
          backgroundColor:
            customColor && customColor.background && customColor.background.app
              ? customColor.background.app
              : THEME.COLORS.BACKGROUND_MAIN,
        }}
      >
        <StandardText
          color={
            customColor && customColor.text && customColor.text.app
              ? customColor.text.app
              : THEME.COLORS.TEXT_MAIN
          }
          style={{
            fontFamily:
              customFont && customFont.fontFamilySubtitle
                ? customFont.fontFamilySubtitle
                : THEME.FONTFAMILY.MEDIUM,
            fontSize:
              customFont && customFont.fontMD
                ? customFont.fontMD
                : THEME.FONTSIZE.MEDIUM,
          }}
        >
          Ops, acesso negado!
        </StandardText>
        <SmallText
          margin="2rem"
          color={
            customColor && customColor.text && customColor.text.app
              ? customColor.text.app
              : THEME.COLORS.TEXT_MAIN
          }
          style={{
            fontFamily:
              customFont && customFont.fontFamilyText
                ? customFont.fontFamilyText
                : THEME.FONTFAMILY.REGULAR,
            fontSize:
              customFont && customFont.fontSM
                ? customFont.fontSM
                : THEME.FONTSIZE.SMALL,
          }}
        >
          Se você já possui cadastro, clique no botão abaixo para fazer login com o seu email e senha:
        </SmallText>
        <Button
          title={'Login'}
          onPress={() => navigation.navigate('Login')}
          colorbutton={
            customColor && customColor.button && customColor.button.backgroundApp
              ? customColor.button.backgroundApp
              : THEME.COLORS.PRIMARY_800
          }
          colortitle={
            customColor && customColor.button && customColor.button.textApp
              ? customColor.button.textApp
              : THEME.COLORS.TEXT_BUTTON
          }
        ></Button>
      </Container>
    );
  }

  return (
    <PaperProvider
      background={
        customColor && customColor.background && customColor.background.app
          ? customColor.background.app
          : THEME.COLORS.BACKGROUND_MAIN
      }
    >
      {loadingCard ? (
        <ActivityIndicator
          style={{
            flex: 1,
            backgroundColor:
              customColor &&
              customColor.background &&
              customColor.background.auth
                ? customColor.background.auth
                : THEME.COLORS.BACKGROUND_ABOUT,
            justifyContent: 'center',
          }}
          color={
            customColor && customColor.primary
              ? customColor.primary
              : THEME.COLORS.PRIMARY_800
          }
        />
      ) : (
        <S.ContainerCommunity
          style={{
            backgroundColor:
              customColor &&
              customColor.background &&
              customColor.background.app
                ? customColor.background.app
                : THEME.COLORS.BACKGROUND_MAIN,
          }}
        >
          <View>
            <Header
              onPress={() => {
                isUser.isAdmin
                  ? navigation.navigate('Admin', { screen: 'Conteudo' })
                  : navigation.navigate('Conteudo', { screen: 'Aplicativo' });
              }}
              user={isUser}
            />
          </View>
          {/* Canais como pílulas: o selecionado preenchido na cor de botão da
              marca, os demais apenas contornados — antes todos tinham a borda
              forte e só o fundo mudava, o que competia com o conteúdo. */}
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, paddingHorizontal: 16, paddingVertical: 12 }}>
            {isUser?.isAdmin && (
              <ChannelManager onPress={() => setIsManageChannelsModalVisible(true)} />
            )}
            <ScrollView horizontal showsHorizontalScrollIndicator={false}>
              {channels.map((channel) => {
                const isSelected = channel.id === selectedChannelId;
                return (
                  <TouchableOpacity
                    key={channel.id}
                    onPress={() => setSelectedChannelId(channel.id)}
                    activeOpacity={0.75}
                    style={{
                      paddingHorizontal: 14,
                      minHeight: 36,
                      justifyContent: 'center',
                      marginRight: 8,
                      borderRadius: 999,
                      borderWidth: 1,
                      borderColor: isSelected ? clientBtnBg : cBorder,
                      backgroundColor: isSelected ? clientBtnBg : 'transparent',
                    }}
                  >
                    <Text
                      numberOfLines={1}
                      style={{
                        fontFamily: cFontTitle,
                        fontSize: 14,
                        color: isSelected ? clientBtnText : clientText,
                      }}
                    >
                      {channel.name}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </ScrollView>
          </View>

          <S.Container
            style={{
              backgroundColor:
                customColor &&
                customColor.background &&
                customColor.background.app
                  ? customColor.background.app
                  : THEME.COLORS.BACKGROUND_MAIN,
            }}
          >
            {canUserPostOnSelectedChannel && (
              <S.Touch
                style={{ backgroundColor: clientBtnBg }}
                onPress={() => setIsPostModalVisible(true)}
                accessibilityLabel="Criar publicação"
              >
                <Feather name="edit-2" size={22} color={clientBtnText} />
              </S.Touch>
            )}
            {posts.length === 0 ? (
              /* Estado vazio com ícone e hierarquia, em vez de uma frase solta
                 no meio da tela. */
              <View style={{ alignItems: 'center', paddingHorizontal: 32, gap: 6 }}>
                <View
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: 36,
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: cSurface,
                    borderWidth: 1,
                    borderColor: cBorder,
                    marginBottom: 6,
                  }}
                >
                  <Ionicons name="chatbubbles-outline" size={32} color={cMuted} />
                </View>
                <Text
                  style={{
                    fontFamily: cFontTitle,
                    fontSize: 17,
                    color: clientText,
                    textAlign: 'center',
                  }}
                >
                  {canUserPostOnSelectedChannel
                    ? 'Comece a conversa'
                    : 'Ainda não há publicações'}
                </Text>
                <Text
                  style={{
                    fontFamily: cFontText,
                    fontSize: 14,
                    color: cMuted,
                    textAlign: 'center',
                    lineHeight: 20,
                  }}
                >
                  {canUserPostOnSelectedChannel
                    ? 'Toque no botão de escrever para fazer a primeira publicação deste canal.'
                    : 'Assim que alguém publicar neste canal, as postagens aparecem aqui.'}
                </Text>
              </View>
            ) : (
              <CardCommunity
                posts={posts}
                handleLike={handleLike}
                handleDeletePost={handleDeletePost}
                user={isUser}
                setPosts={setPosts}
              />
            )}
            <Modal
              visible={isPostModalVisible}
              animationType="fade"
              transparent={true}
            >
              <S.ModalBackground>
                <View
                  style={{
                    width: '100%',
                    maxWidth: 480,
                    backgroundColor: clientBg,
                    borderRadius: 16,
                    borderWidth: 1,
                    borderColor: cBorder,
                    boxShadow: '0 12px 32px rgba(16,24,40,0.25)',
                    overflow: 'hidden',
                  }}
                >
                  {/* Cabeçalho com título e fechar, no padrão dos demais modais */}
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: 12,
                      padding: 16,
                      borderBottomWidth: 1,
                      borderBottomColor: cBorder,
                    }}
                  >
                    <Text style={{ flex: 1, minWidth: 0, fontFamily: cFontTitle, fontSize: 17, color: clientText }}>
                      Nova publicação
                    </Text>
                    <TouchableOpacity onPress={closeModal} hitSlop={8}>
                      <Ionicons name="close" size={22} color={cMuted} />
                    </TouchableOpacity>
                  </View>

                  <ScrollView style={{ maxHeight: '60vh' }} contentContainerStyle={{ padding: 16 }}>
                    {/* Área de imagem como "drop zone" tracejada: comunica que é
                        clicável e opcional, em vez de um ícone solto. */}
                    <TouchableOpacity
                      onPress={openImagePicker}
                      activeOpacity={0.8}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                        paddingVertical: image ? 0 : 28,
                        borderRadius: 12,
                        borderWidth: image ? 0 : 1,
                        borderStyle: 'dashed',
                        borderColor: cBorder,
                        backgroundColor: image ? 'transparent' : cSurface,
                        overflow: 'hidden',
                      }}
                    >
                      {image ? (
                        <Image
                          source={{ uri: image }}
                          style={{ width: '100%', aspectRatio: 1, borderRadius: 12 }}
                          resizeMode="cover"
                        />
                      ) : (
                        <>
                          <Ionicons name="image-outline" size={32} color={cMuted} />
                          <Text style={{ fontFamily: cFontText, fontSize: 14, color: cMuted }}>
                            Adicionar uma imagem (opcional)
                          </Text>
                        </>
                      )}
                    </TouchableOpacity>

                    {image ? (
                      <TouchableOpacity onPress={openImagePicker} style={{ alignSelf: 'flex-start', marginTop: 8 }}>
                        <Text style={{ fontFamily: cFontText, fontSize: 13, color: cMuted }}>
                          Trocar imagem
                        </Text>
                      </TouchableOpacity>
                    ) : null}

                    {messageImageError && (
                      <Text
                        style={{
                          fontFamily: cFontText,
                          fontSize: 13,
                          color: THEME.COLORS.ALERT,
                          marginTop: 8,
                        }}
                      >
                        O tipo de arquivo selecionado é inválido
                      </Text>
                    )}

                    <View style={{ marginTop: 16 }}>
                      <BrandInput
                        placeholder="Escreva uma legenda"
                        multiline
                        returnKeyType="go"
                        onChangeText={setTextContent}
                        value={textContent}
                      />
                    </View>
                  </ScrollView>

                  <View
                    style={{
                      flexDirection: 'row',
                      justifyContent: 'flex-end',
                      gap: 12,
                      padding: 16,
                      borderTopWidth: 1,
                      borderTopColor: cBorder,
                    }}
                  >
                    <TouchableOpacity
                      onPress={closeModal}
                      disabled={loading}
                      style={{
                        minHeight: 44,
                        paddingHorizontal: 20,
                        borderRadius: 10,
                        borderWidth: 1,
                        borderColor: cBorder,
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Text style={{ fontFamily: cFontTitle, fontSize: 14, color: clientText }}>
                        Cancelar
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={handlePost}
                      disabled={loading}
                      style={{
                        minHeight: 44,
                        paddingHorizontal: 24,
                        borderRadius: 10,
                        backgroundColor: clientBtnBg,
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: loading ? 0.7 : 1,
                      }}
                    >
                      {loading ? (
                        <ActivityIndicator size="small" color={clientBtnText} />
                      ) : (
                        <Text style={{ fontFamily: cFontTitle, fontSize: 14, color: clientBtnText }}>
                          Publicar
                        </Text>
                      )}
                    </TouchableOpacity>
                  </View>
                </View>
              </S.ModalBackground>
            </Modal>
            <ManageChannelsModal
              visible={isManageChannelsModalVisible}
              channels={allChannels}
              onClose={() => setIsManageChannelsModalVisible(false)}
              onCreate={() => {
                setIsManageChannelsModalVisible(false);
                setIsCreateChannelModalVisible(true);
              }}
              onEdit={(channel) => {
                setChannelToEdit(channel);
                setIsManageChannelsModalVisible(false);
                setIsEditChannelModalVisible(true);
              }}
              onDelete={async (channel) => {
                const shouldDelete = typeof window === 'undefined' ? true : window.confirm(`Deseja excluir o canal "${channel.name}"?`);
                if (!shouldDelete) return;
                await deleteChannel(channel.id);
              }}
              onMove={(channel, direction) => moveChannel(channel.id, direction)}
            />
            <ChannelFormModal
              visible={isCreateChannelModalVisible}
              title="Novo canal"
              submitLabel="Criar"
              initialValue={null}
              onClose={() => setIsCreateChannelModalVisible(false)}
              onSubmit={createChannel}
            />
            <EditChannelModal
              visible={isEditChannelModalVisible}
              channel={channelToEdit}
              onClose={() => {
                setIsEditChannelModalVisible(false);
                setChannelToEdit(null);
              }}
              onSubmit={(payload) => updateChannel(channelToEdit?.id, payload)}
            />
          </S.Container>
        </S.ContainerCommunity>
      )}
    </PaperProvider>
  );
};

export default Community;
